<app-maintenance-mode-alert></app-maintenance-mode-alert>
<app-location-context-panel></app-location-context-panel>

<!-- Content -->
<div class="content">
    <mat-card>
        <mat-card-content>
            <div class="container">
                <h1>Error Logs</h1>

                <app-loading-indicator [loading]="loading"></app-loading-indicator>

                <div class="top-controls">
                    <!-- Filter -->
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                    </mat-form-field>

                     <!-- Clear -->
                    <div>
                        <button mat-raised-button color="primary" class="clear" type="submit" (click)="confirmClearLogs()">Clear Logs</button>
                    </div>
                </div>

                <!-- Table -->
                 <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" aria-describedby="error-logs-table">
                    <!-- Error Date -->
                    <ng-container matColumnDef="dateString">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="dateString">Date</th>
                        <td mat-cell *matCellDef="let errorLog">{{ errorLog?.dateString | date: 'dd-MM-yyyy hh:mm'}}</td>
                    </ng-container>
                    
                    <!-- Error Type -->
                    <ng-container matColumnDef="errorType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="errorType">Type</th>
                        <td mat-cell *matCellDef="let errorLog">{{ errorLog?.errorType }}</td>
                    </ng-container>
    
                    <!-- Error Message -->
                    <ng-container matColumnDef="errorMessage">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="errorMessage">Error Message</th>
                        <td mat-cell *matCellDef="let errorLog">{{ errorLog?.errorMessage }}</td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"
                        (click)="showDetail(row)"></tr>
                </table>

                <!-- No Data Message -->
                <div class="no-data" *ngIf="!loading && (dataSource.data.length === 0 || dataSource.filteredData.length === 0)">
                    <span>No data found</span>
                </div>

                <!-- Pager -->
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>